/* eslint-disable @typescript-eslint/no-explicit-any */
import type { HttpConfig } from "@iap/kit-http";
import analyticsBridge from "@/betby/adapters/analytics/analyticsBridge";
import {
  clearAuthState,
  notifyTokenExpired,
  notifyLoginRequired,
} from "@/betby/api/httpRuntimeAdapter";
import { logger } from "@/betby/api/httpLogger";
import {
  TRACK_EVENT_MAINTENANCE_SPM,
  MAINTENANCE_TRIGGER,
} from "@/betby/utils/TrackEvents";

export type ErrorHandler = (data: any, config: HttpConfig) => any;

export const customErrorHandler: ErrorHandler = async (
  data: any,
  config: HttpConfig,
) => {
  const { code, message } = data || {};

  if (code === 200) {
    return data;
  }

  if ((config.options as any)?.skipGlobalErrorHandler) {
    if ((config.options as any)?.showUnrecognizedErrorModal && code !== 200) {
      if (typeof window !== "undefined") {
        const msg =
          message && String(message).trim()
            ? String(message)
            : "We're sorry, an error occurred. Please try re-entering the sports play later.";
        notifyTokenExpired(msg, "Network Error");
      }
    }
    return data;
  }

  switch (code) {
    case -1:
      break;
    case 401:
    case 4014:
    case 4015:
      logger.warn(
        `[customErrorHandler] 捕获 Token 被顶错误码 ${code}，直接执行退出流程`,
      );
      if (typeof window !== "undefined") {
        clearAuthState();
        notifyTokenExpired();
      }
      break;
    case 4011:
    case 4012:
    case 4013:
      logger.warn(
        `[customErrorHandler] 捕获登录态失效错误码 ${code}，触发登录回调`,
      );
      if (typeof window !== "undefined") {
        clearAuthState();
        notifyLoginRequired();
      }
      break;
    case 403:
      logger.error("无权限访问:", message);
      break;
    case 500:
      logger.error("服务器错误:", message);
      break;
    case 7001:
      if (typeof window !== "undefined") {
        try {
          analyticsBridge.track(TRACK_EVENT_MAINTENANCE_SPM, {
            src: 516,
            eb_key1: MAINTENANCE_TRIGGER.SERVER_MAINTENANCE,
          });
        } catch (error) {
          logger.error("[http] maintenance track error", error);
        }
      }
      notifyTokenExpired(
        "The Servers are under maintenance. Please check back soon.",
        "Server Maintenance",
      );
      break;
    default:
      if (config.isSerErrTips && message) {
        logger.error("请求失败:", message);
      }
      if (
        (config.options as any)?.showUnrecognizedErrorModal &&
        typeof window !== "undefined"
      ) {
        notifyTokenExpired(
          "We're sorry, an error occurred. Please try re-entering the sports play later.",
        );
      }
  }

  return data;
};
